module.exports = __webpack_public_path__ + "img/business_16.5fee3ac1.jpg";